import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import vuetify from "@/plugins/vuetify";
import VueAuthenticate from 'vue-authenticate';
import store from '@/store'
import i18n from '@/i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import {faEdit, faCheck, faBox, faCross, faExclamation, faQuestion} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faEdit, faCheck, faBox, faCross, faExclamation, faQuestion);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueAuthenticate, {
  baseUrl: store.state.siteUrl, // Your API domain

  providers: {
    google: {
      name: 'google-oauth2',
      url: store.state.endpoints.socialAuth,
      clientId: '877782956685-kshiteuo5g7eah75f2hrrg2pi17v0r0s.apps.googleusercontent.com',
      redirectUri: store.state.authRedirectUri
    },
    facebook: {
      name: 'facebook',
      url: store.state.endpoints.socialAuth,
      clientId: '2045132515633341',
      redirectUri: store.state.authRedirectUri
    }
  }
});

Vue.config.productionTip = false;

// import messages from './i18n'

// if (localStorage.getItem('lang')) {
//   store.commit('setLanguage', localStorage.getItem('lang'))
// }

// import {markScripts} from "@/funclib";
// eslint-disable-next-line no-console
// console.log(markScripts('فم\n' +
//     'כְּפִּי ، לְפִּי – على حسب', 'AR'));
// eslint-disable-next-line no-console
// console.log(markScripts('עָשָֹה'))
// import {test} from '@/db/CardStatus';
// test();

new Vue({
  store: store,
  router: router,
  i18n: i18n,
  vuetify: vuetify,
  render: h => h(App),
  mounted () {
    this.$store.dispatch('getUserInfo');
  }
}).$mount('#app');
